// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IDeleteOfferFromComparisonRequest,
  TDeleteOfferFromComparisonModel,
  IMappers,
  TDeleteOfferFromComparisonResponse,
  IDeleteOfferFromComparisonResponse,
  IDeleteOfferFromComparisonResponseError,
} from './types';

export const defaultConfig: TDeleteOfferFromComparisonModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'offers-comparison',
  pathApi: '/v1/delete-offer-from-comparison/',
  requestType: 'json',
  responseType: 'json',
} as TDeleteOfferFromComparisonModel;

export function createDeleteOfferFromComparisonModel(
  parameters: IDeleteOfferFromComparisonRequest,
): TDeleteOfferFromComparisonModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDeleteOfferFromComparisonOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IDeleteOfferFromComparisonRequest;
}

export async function fetchDeleteOfferFromComparison<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDeleteOfferFromComparisonOptions<TResponse200, TResponse400>): Promise<
  TDeleteOfferFromComparisonResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createDeleteOfferFromComparisonModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IDeleteOfferFromComparisonResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IDeleteOfferFromComparisonResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TDeleteOfferFromComparisonResponse;
}
